import { useContext } from "react";
import { AppContext } from "../App";
import ServicesLanding from "../views/ServicesLanding";

export default function Services() {
  const appContext = useContext(AppContext);

  if (!appContext.navSubItem && !appContext.navExtraItem && !appContext.navMoreItem) {
    return <ServicesLanding />;
  }

  return null;
}

